export default "__VITE_ASSET__56b41c41__"